module.exports = "<div>\n  <div *ngFor='let obj of ss.projectsLs'>\n    <input type='checkbox' (click)='selectSeed(obj[\"id\"])'/>\n    {{obj[\"title\"]}}\n  </div>\n  <div>\n    <button (click)='run()'>Run seed</button>\n    <button (click)='runSupport()'>Run support (tags, ...)</button>\n  </div>\n  <div>\n    Filename(no suffix): <input [(ngModel)]='fn' />\n  </div>\n\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/seed-box/seed-box.component.html
// module id = 440
// module chunks = 0